// extracted by mini-css-extract-plugin
export default {"contentContainer":"NavbarLayout_contentContainer__rPKfj","logoHolder":"NavbarLayout_logoHolder__WhafM","networkLogo":"NavbarLayout_networkLogo__oLA6j"};